import styled from 'styled-components';
import type { BrandFilterViewModel } from 'autogen/swagger/all';
import useDrawer from 'components/generic/Drawer/hooks/useDrawer';
import { Typography } from 'components/generic/typography';
import FilterListItem from 'components/List/components/FilterListItem';
import { findNSelectedOptions } from '../shared/helpers';

const PreviewText = styled(Typography.Body)`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 50%;
`;

export default function RootBrandFilterMenuItem({ model }: { model: BrandFilterViewModel }) {
    const {
        displayName,
        brands,
        attribute: { id }
    } = model;
    const filterMenuId = id.toString();
    const { toggle } = useDrawer(filterMenuId);
    const selectedOptions = findNSelectedOptions(brands.options, 8).map((option) => option.displayName);
    const selectedOptionsPreviewText = !!selectedOptions.length && (
        <PreviewText forwardedAs="span" size="S" strong>
            {selectedOptions.join(', ')}
        </PreviewText>
    );

    return (
        <FilterListItem.Button
            type="navigation"
            selectedPreview={selectedOptionsPreviewText}
            buttonProps={{ onClick: toggle }}
        >
            {displayName}
        </FilterListItem.Button>
    );
}
